// extracted by mini-css-extract-plugin
module.exports = {"loading":"RecordLoadingComponent_loading_2egbL"};